<template>
  <section style="background-color: white;">
    <div class="container section">
      <b-loading
        :is-full-page="true"
        :active.sync="isLoading"
        :can-cancel="false"
      ></b-loading>
      <div class="column is-full">
        <h1 class="title">
          {{ $t('Más información') }}
        </h1>
        <b-field label="Grupo">
          <b-select placeholder="Select a name" v-model="selectedSector">
            <option
              :value="sector"
              :key="sector"
              v-for="sector of Object.keys(detailedBusinessSectors)"
            >
              {{ $t(sector) }}
            </option>
          </b-select>
        </b-field>
        <b-field label="Sector" v-if="selectedSector">
          <b-select placeholder="Select a name">
            <option
              :key="sector"
              :value="sector"
              v-for="sector of subSectors()"
            >
              {{ $t(sector) }}
            </option>
          </b-select>
        </b-field>
        <hr />

        <b-field position="is-centered">
          <button class="button is-primary">
            {{ $t('Enviar') }}
          </button>
        </b-field>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import EnumeratesFormater from '@/mixins/enumeratesFormater.js'
import DetailedBusinessSectors from '@/constants/detailed_business_sectors.js'

export default {
  props: ['id'],
  mixins: [EnumeratesFormater],
  components: {},
  data() {
    return {
      isLoading: true,
      requestData: {
        phase1: null
      },
      detailedBusinessSectors: null,
      selectedSector: null
    }
  },
  created() {
    this.detailedBusinessSectors = DetailedBusinessSectors
  },
  mounted() {
    this.loadRequestData()
  },
  computed: {
    ...mapGetters('onBoard', ['neofintechData'])
  },
  beforeRouteLeave(routeTo, routeFrom, next) {
    this.$store.commit('onBoard/SET_NEOFINTECH_PHASE_1_RESET')
    next()
  },
  methods: {
    ...mapActions('onBoard', ['getOnboardRequestDetails']),
    loadRequestData: function() {
      let self = this

      this.getOnboardRequestDetails(this.id)
        .then(function(response) {
          self.$store.commit(
            'onBoard/SET_NEOFINTECH_PHASE_1',
            response.data.phase1
          )
        })
        .catch(function(e) {
          console.log(e)
        })
        .finally(function() {
          self.isLoading = false
        })
    },
    subSectors: function() {
      return this.detailedBusinessSectors[this.selectedSector]
    }
  }
}
</script>

<style></style>
